import * as React from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import { createCategoryBreadcrumb } from './utils/create-category-breadcrumb.js';
import { createGraphProductBreadcrumb } from './utils/create-graph-product-breadcrumb.js';
import { createGraphSubCategoryBreadcrumb } from './utils/create-graph-subcategory-breadcrumb.js';
import { getCategoryRoute } from './utils/get-category-route.js';
import { useBrPageContext } from '../../../context/context.js';

const CmsGraphProductBreadcrumbs = ({ variant , productType , brandName ,  })=>{
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const page = useBrPageContext();
    if (!page) {
        console.error(`Missing Page from Bloomreach.`);
    }
    const categoryRoute = getCategoryRoute(productType, page);
    if (!categoryRoute) {
        console.warn('Could not find a product category route to render PDP breadcrumbs');
        return null;
    }
    const categoryBreadcrumb = createCategoryBreadcrumb(categoryRoute, page);
    const subCategoryBreadcrumb = isSubcategoryPlpLinkingDisabled ? null : createGraphSubCategoryBreadcrumb(categoryRoute, brandName, page, variant);
    const productBreadcrumb = createGraphProductBreadcrumb(categoryBreadcrumb, variant.displayName, brandName);
    const breadcrumbs = [
        categoryBreadcrumb,
        subCategoryBreadcrumb,
        productBreadcrumb
    ].filter(Boolean);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};
var CmsGraphProductBreadcrumbs$1 = CmsGraphProductBreadcrumbs;

export { CmsGraphProductBreadcrumbs, CmsGraphProductBreadcrumbs$1 as default };
//# sourceMappingURL=GraphProductBreadcrumbs.js.map
